"use client";
import { useLocale } from "next-intl";
import { Anchor, Box, Group, Text } from "@mantine/core";
import { Link } from "@/i18n/navigation";
export default function KibbeConceptLinks() {
  const locale = useLocale();
  if (locale !== "en") return null;
  return <Box my="xl"><Text fw={600} mb="sm">Make sense of the clothing lines</Text><Group gap="lg"><Anchor component={Link} href="/kibbe-width">Kibbe width, with outfit examples</Anchor><Anchor component={Link} href="/kibbe-double-curve">Double curve and the whole silhouette</Anchor></Group></Box>;
}
